// main.js
import { createApp } from 'vue'
import App from '@v/tangApp.vue'

// ...

// let PageArticle = {
//     template: `{{ cmsData }}`,
//     props: {
//         cmsData: {
//             type: Array,
//             required: true,
//         }
//     },
//
//     setup (props) {
//         console.log(props)
//     },
//
// }

function initTangFeed() {
    const app = createApp(App)
// app.component('page-article', PageArticle)
    app.mount('#tang-feed-component-fetch')
}

// Make it globally available
window.initTangFeed = initTangFeed;

// Re-run whenever Sprig/htmx swaps in new content that might contain a player
document.body.addEventListener('htmx:afterSwap', (e) => {
    // Check if the swapped content (or its children) has the video element
    if (e.detail.target.matches('#tang-feed-component-fetch') || e.detail.target.querySelector('#tang-feed-component-fetch')) {
        initTangFeed();
    }
});

// Also run once on initial load
document.addEventListener('DOMContentLoaded', initTangFeed);